import register from '@kpsys/angularjs-register';
import SearchHistoryDataService from './search-history-page/search-history.data-service';
import {SearchService} from './search.service';
import {SearchDataService} from './search.data-service';
import {SearchPageService} from './kp-search-page/search-page.service';
import {SearchManagerBuilderFactoryService} from './search-manager/search-manager-factory.service';
import {SearchedLoansService} from './kp-resolvable-search-results-displayer/kp-search-result-table-loans/searched-loans-service';
import {KpSearchItemAuthorityPresenter} from './kp-resolvable-search-results-displayer/kp-search-item-authority/kp-search-item-authority.presenter';
import {KpSearchItemDocumentPresenter} from './kp-resolvable-search-results-displayer/kp-search-item-document/kp-search-item-document.presenter';
import {KpSearchItemUserPresenter} from './kp-resolvable-search-results-displayer/kp-search-item-user/kp-search-item-user.presenter';
import {KpSearchPageComponent} from './kp-search-page/kp-search-page.component';
import {KpSearchHistoryService} from './search-history-page/kp-search-history.service';
import {searchHistoryRoutes} from './search-history-page/search-history.routes';
import {searchFormRoutes} from './search-form-page/search-form.routes';
import {SearchFormDataService} from './search-form-page/search-form.data-service';
import {KpSearchFormService} from './search-form-page/kp-search-form.service';
import {KpSearchHistoryPanelPresenter} from './kp-search-history-panel/kp-search-history-panel.presenter';

/**
 * @ngdoc module
 * @name portaro.features.search
 * @module portaro.features.search
 */
export default register('portaro.features.search')
    .service(SearchService.serviceName, SearchService)
    .service(SearchHistoryDataService.serviceName, SearchHistoryDataService)
    .service(SearchDataService.serviceName, SearchDataService)
    .service(SearchPageService.serviceName, SearchPageService)
    .service(SearchedLoansService.serviceName, SearchedLoansService)
    .service(SearchManagerBuilderFactoryService.serviceName, SearchManagerBuilderFactoryService)
    .component(KpSearchPageComponent.componentName, KpSearchPageComponent)
    .service(KpSearchHistoryService.serviceName, KpSearchHistoryService)
    .service(SearchFormDataService.serviceName, SearchFormDataService)
    .service(KpSearchFormService.serviceName, KpSearchFormService)
    .service(KpSearchHistoryPanelPresenter.presenterName, KpSearchHistoryPanelPresenter)
    // Search Items
    .service(KpSearchItemAuthorityPresenter.presenterName, KpSearchItemAuthorityPresenter)
    .service(KpSearchItemDocumentPresenter.presenterName, KpSearchItemDocumentPresenter)
    .service(KpSearchItemUserPresenter.presenterName, KpSearchItemUserPresenter)
    // Routes
    .config(searchHistoryRoutes)
    .config(searchFormRoutes)
    .name();